<div class="modal-content" #scrollContainer (scroll)="onModalScroll($event)">
  <div class="close">
    <lib-button icon="close" color="none" class="action" (click)="close()"></lib-button>
  </div> 
  <!-- LEFT -->
  <div class="left" #drawerSection>
    <app-base-drawer class="drawer"
      [imageUrl]="imageUrl"
      [boxes]="drawerBoxes"
      [activeIndex]="activeIndex"
      [disabled]="!canEdit"
      [readOnly]="!canEdit"
      [hideTools]="hideDrawerTools"
      [pendingLabel]="pendingBoxLabel()"
      (boxCreated)="onBoxCreated($event)"
      (boxSelected)="onBoxSelected($event)"
      (boxChanged)="onBoxChanged($event)"
      (boxDeleted)="onBoxDeleted($event)"
      (interactionStart)="onInteractionStart()"
      (boxOpened)="onBoxOpened($event)"
      (boxHovered)="onBoxHovered($event)"
      (boxUnhovered)="scheduleHoverClose()">
    </app-base-drawer>

    <div class="btn-group">
      <lib-button icon="arrow_left" color="none" class="action" (click)="prevImage()" [disabled]="!canGoLeft"></lib-button>
      <div class="image-info">Date: {{ image.createdDate | timeFormat : 'dd/MM/yyyy HH:mm:ss'}}</div>
      <lib-button icon="arrow_right" color="none" class="action" (click)="nextImage()" [disabled]="!canGoRight"></lib-button>
    </div>
  </div>

  <!-- RIGHT -->
  <div class="right" #formsSection>
    <fieldset class="detected-risks">
      <legend>{{ 'risks.detected_risks' | translate }}</legend>
      <div *ngIf="!riskNames.length" class="empty">—</div>
      <span *ngFor="let r of riskNames; let last = last" class="risk-name"
        [class.active]="r.index === activeIndex" (click)="selectTag(r.index)">
        {{ r.name }}{{ last ? '' : ', ' }}
      </span>
    </fieldset>

    <div class="tab-content" *ngIf="canEdit">
      <div class="label-search">
        <h3>Liste des labels</h3>
        <app-search-bar
          [value]="searchText"
          [width]="130"
          (searchText)="applyFilter($event)"
          (enterPressed)="onEnterPressed()"
          (inputBlur)="onInputBlur()">
        </app-search-bar>
      </div>

      <div class="label-list">
        <div *ngFor="let label of visibleLabels()" class="label-item"
          (click)="selectLabel(label, true)"
          [class.active]="isSelected(label)"
          [style.background]="getLabelBackground(label.color || '#ffffff', isSelected(label))">
          <span class="label-text" [style.color]="getDarkerColor(label.color || '#ffffff')">
            {{ label.displayName || label.name }}
          </span>
        </div>
      </div>
    </div>

    <div class="btn-group">
      <lib-button *ngIf="canEdit || hasChange" icon="save" color="primary" class="action" [text]="'form.save'|translate" (click)="saveAndClose()"></lib-button>
      <lib-button *ngIf="risk" icon="error" color="warning" class="action" [text]="'risks.report_title'|translate" (click)="reportRisk()"></lib-button>
    </div>
  </div>

</div>
